import axios from 'axios';
import { useMutation } from 'react-query';

import getBaseApi from '@luna-protocol/core/src/utils/getBaseApi';
import { LoginResponse } from '@luna-protocol/core/src/types';
import { getDealerIdFromToken } from '@luna-protocol/core/src/utils/getDealerIdFromToken';

export interface LoginSwitchRequest {
  user_id: string;
}

const usePostLoginSwitch = () => {
  const mutation = useMutation(async (request: LoginSwitchRequest) => {
    const resp = await axios.post(`${getBaseApi()}/dealer/login/switch`, JSON.stringify(request), {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('user_token')}`,
      },
    });

    if (resp.status !== 200) {
      throw new Error('Login switch failed');
    }

    localStorage.setItem('user_token', resp.data.token);
    localStorage.setItem('dealer_id', getDealerIdFromToken(resp.data.token));
    return resp.data as LoginResponse;
  });

  return {
    switchDealer: mutation.mutate,
    ...mutation,
  };
};

export { usePostLoginSwitch };
